import { render, staticRenderFns } from "./GroupReport.vue?vue&type=template&id=69810e74&scoped=true"
import script from "./GroupReport.vue?vue&type=script&lang=js"
export * from "./GroupReport.vue?vue&type=script&lang=js"
import style0 from "./GroupReport.vue?vue&type=style&index=0&id=69810e74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69810e74",
  null
  
)

export default component.exports